var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonalContact = function SvgPersonalContact(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7627 17.041L11.042 20H1V18C1 15.6011 5.3351 14.2781 8.14453 14.041L11.7627 17.041ZM7.52832 16.1289C6.46866 16.2887 5.29382 16.5942 4.35449 17.0264C3.76395 17.2981 3.37449 17.5706 3.1582 17.7939C3.05475 17.9008 3.01711 17.9684 3.00391 18H9.4707L9.52246 17.7822L7.52832 16.1289ZM11 8C11 6.89457 10.1054 6 9 6C7.89457 6 7 6.89457 7 8C7 9.01704 7.75937 9.85434 8.74316 9.97949L9.57715 9.91211C10.4016 9.66467 11 8.90181 11 8ZM13 8C13 9.89083 11.6893 11.4727 9.92676 11.8906L8.7168 11.9883C6.63914 11.8431 5 10.1147 5 8C5 5.79 6.79 4 9 4C11.21 4 13 5.79 13 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5879 13.6924L18.709 13.9639L19.0049 13.9883L21.7344 14.209L19.6777 15.915L19.4375 16.1143L19.5107 16.418L20.1357 18.9814L17.75 17.6035L17.5 17.459L17.25 17.6035L14.8633 18.9814L15.4893 16.418L15.5625 16.1143L15.3223 15.915L13.2646 14.209L15.9951 13.9883L16.291 13.9639L16.4121 13.6924L17.5 11.2344L18.5879 13.6924Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonalContact);
export { ForwardRef as ReactComponent };